import React, { ReactElement } from "react";

import { Loader, ErrorGlobal } from "src/components";
import { useGetFeatureFlagsQuery } from "src/graphql/generated/queries";
import { useAuthStore } from "src/stores/auth-store";

interface Props {
  children: ReactElement;
}

export const FeatureFlagsWrapper = ({ children }: Props) => {
  const logout = useAuthStore((state) => state.logout);

  const { data, isLoading, error } = useGetFeatureFlagsQuery();

  if (error) {
    return <ErrorGlobal onLogout={logout} />;
  }

  if (isLoading || !data) {
    return <Loader />;
  }

  return children;
};
